'use client';

import classNames from 'classnames';
import type Tag from '@alltrails/core/types/Tag';
import CheckSm from '@alltrails/denali/icons/CheckSm';
import icons from './tagIconMapping';
import styles from './PlanYourVisit.module.scss';

type GroupTagProps = {
  tag: Tag;
  isLightBackground: boolean;
  className?: string;
};

const GroupTag = ({ tag, isLightBackground, className }: GroupTagProps) => {
  const Icon = icons[tag.uid] || CheckSm;
  return (
    <div className={classNames(styles.tag, className)}>
      <div className={classNames(styles.iconBackground, { [styles.light]: isLightBackground })}>
        <Icon size="sm" />
      </div>
      <div className={styles.tagName}>{tag.name}</div>
    </div>
  );
};

export default GroupTag;
